import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-dash-board1',
  templateUrl: './dash-board1.component.html',
  styleUrls: ['./dash-board1.component.css']
})
export class DashBoard1Component implements OnInit {

  dashboardData: any;
  metadata: any;
  layout: any;
  userCred: any;
  dashboard1: boolean = false;
  dashboard2: boolean = false;
  dashboard3: boolean = false;
  dashboard4: boolean = false;

  dashboard: any = "Asset distribution dashboard";


  options: any
  barOptions: any


  // Asset Charts
assetsByTypePieData: any;
assetsAcrossYearsBarData: any;
assetsByTemplateBarData: any;

assetsOriginalCostByBranchPieData: any;
assetsCurrentCostByBranchPieData: any;
assetsCostByTypeBarData: any;

// Ticket Charts
ticketsByStatusBarData: any;
ticketsByExpectedStartMonthBarData: any;
ticketsByExpectedClosingMonthBarData: any;

  constructor(
    private eRef: ElementRef,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService) { }

  ngOnInit(): void {
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);


this.options = {
  plugins: {
    legend: {
      display: true,
      position: 'top',
      onClick: () => {}, // disables click toggling
      labels: {
        usePointStyle: true, // no circle/point
      }
    }
  }
}

this.barOptions = {
  plugins: {
    legend: {
      display: true,
      position: 'bottom',  // ✅ place legend below chart
      onClick: () => {}, // disables click toggling
      labels: {
        usePointStyle: true, // no circle/point
        boxWidth: 0        // ⛔ removes the colored box
      }
    }
  }
}

    this.loadAllDashboardCharts() 

  }


loadAllDashboardCharts() {

  // Asset Charts
  this.assetsByTypePieChartDashboard();
  this.assetsAcrossYearsBarChartDashboard();
  this.assetsByTemplateBarChartDashboard();

  this.assetsOriginalCostByBranchPieChartDashboard();
  this.assetsCurrentCostByBranchPieChartDashboard();
  this.assetsCostByTypeBarChartDashboard();

  // Ticket Charts
  this.ticketsByStatusBarChartDashboard();
  this.ticketsByExpectedStartMonthBarChartDashboard();
  this.ticketsByExpectedClosingMonthBarChartDashboard();
}



  dashboardChange(dashboard: any){
    this.dashboard = dashboard
  }



/* -----------------------------------------
   2. Assets by Type (Pie Chart)
------------------------------------------ */
assetsByTypePieChartDashboard() {
  this.generic_service.assetsByTypePieChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item.Type_a1fa27 === null ? "Unknown" : item.Type_a1fa27
        );

        const values = res.response.map((item: any) => item.count_e2942a);

        this.assetsByTypePieData = {
          labels: labels,
          datasets: [
            {
              label: "Assets by Type",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   3. Assets Across Years (Bar Chart)
------------------------------------------ */
assetsAcrossYearsBarChartDashboard() {
  this.generic_service.assetsAcrossYearsBarChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item.acquisitionDate_6cf047 === null ? "Unknown" : item.acquisitionDate_6cf047
        );

        const values = res.response.map((item: any) => item.count_e2942a);

        this.assetsAcrossYearsBarData = {
          labels: labels,
          datasets: [
            {
              label: "Assets Across Years",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   4. Assets by Template (Bar Chart)
------------------------------------------ */
assetsByTemplateBarChartDashboard() {
  this.generic_service.assetsByTemplateBarChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item["Design name"] === null ? "Unknown" : item["Design name"]
        );

        const values = res.response.map((item: any) => item["Number of assets"]);

        this.assetsByTemplateBarData = {
          labels: labels,
          datasets: [
            {
              label: "Assets by Template",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   5. Original Cost by Branch (Pie Chart)
------------------------------------------ */
assetsOriginalCostByBranchPieChartDashboard() {
  this.generic_service.assetsOriginalCostByBranchPieChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item.State === null ? "Unknown" : item.State
        );

        const values = res.response.map((item: any) => item["Original cost"]);

        this.assetsOriginalCostByBranchPieData = {
          labels: labels,
          datasets: [
            {
              label: "Original Cost by Branch",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   6. Current Cost by Branch (Pie Chart)
------------------------------------------ */
assetsCurrentCostByBranchPieChartDashboard() {
  this.generic_service.assetsCurrentCostByBranchPieChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item["State"] === null ? "Unknown" : item["State"]
        );

        const values = res.response.map((item: any) => item["Current cost"]);

        this.assetsCurrentCostByBranchPieData = {
          labels: labels,
          datasets: [
            {
              label: "Current Cost by Branch",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   7. Asset Cost by Type (Bar Chart)
------------------------------------------ */
assetsCostByTypeBarChartDashboard() {
  this.generic_service.assetsCostByTypeBarChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item["Design type"] === null ? "Unknown" : item["Design type"]
        );

        const values = res.response.map((item: any) => item["Original cost"]);

        this.assetsCostByTypeBarData = {
          labels: labels,
          datasets: [
            {
              label: "Asset Cost by Type",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   8. Tickets by Status (Bar Chart)
------------------------------------------ */
ticketsByStatusBarChartDashboard() {
  this.generic_service.ticketsByStatusBarChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item["Latest ticket status"] === null ? "Unknown" : item["Latest ticket status"]
        );

        const values = res.response.map((item: any) => item["Number of tickets"]
);

        this.ticketsByStatusBarData = {
          labels: labels,
          datasets: [
            {
              label: "Tickets by Status",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   9. Tickets by Expected Start Month
------------------------------------------ */
ticketsByExpectedStartMonthBarChartDashboard() {
  this.generic_service.ticketsByExpectedStartMonthBarChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item["Expected start month"] === null ? "Unknown" : item["Expected start month"]
        );

        const values = res.response.map((item: any) => item["Number of tickets"]);

        this.ticketsByExpectedStartMonthBarData = {
          labels: labels,
          datasets: [
            {
              label: "Tickets by opened date",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}


/* -----------------------------------------
   10. Tickets by Expected Closing Month
------------------------------------------ */
ticketsByExpectedClosingMonthBarChartDashboard() {
  this.generic_service.ticketsByExpectedClosingMonthBarChartDashboard().subscribe(
    (res: any) => {
      console.log(res);

      if (res.response && res.response.length !== 0) {

        const labels = res.response.map((item: any) =>
          item["Expected closing month"] === null ? "Unknown" : item["Expected closing month"]
        );

        const values = res.response.map((item: any) => item["Number of tickets"]);

        this.ticketsByExpectedClosingMonthBarData = {
          labels: labels,
          datasets: [
            {
              label: "Tickets by closed date",
              data: values,
              backgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ],
              hoverBackgroundColor: [
                '#4F6D7A','#FF6F61','#6B5B95','#88B04B','#F7CAC9',
                '#92A8D1','#955251','#B565A7','#009B77','#F9B24E',
                '#EAB8A1','#D5B021'
              ]
            }
          ]
        };
      }
    },
    (error: any) => console.log(error)
  );
}



  }



